import classNames from "classnames";
import moment from "moment";
import React from "react";
import { marpolUtils } from "../../../../../redux/app/marpol";
import { TORB1Record } from "../../../../../redux/app/orb1/@types";
import {
	EORB1Item12P4DisposalMethod,
	TORB1GroupC6,
} from "../../../../../redux/app/orb1/groups/group-c";
import CommaSeparator from "../../../../_common/CommaSeparator";
import ORB1TableRows from "../ORB1TableRows";

type OwnProps = {
	orb1Record: TORB1Record;
	isStrikedOff?: boolean;
};
type ORB1GroupC7PreviewProps = React.PropsWithChildren<OwnProps>;
function ORB1GroupC7Preview(props: ORB1GroupC7PreviewProps) {
	const orb1Record = props.orb1Record as TORB1GroupC6;
	if (orb1Record.item12P4.disposalOfOilResidues.length === 0) return null;
	const sourceSludgeTank = orb1Record.item12P4.disposalOfOilResidues[0];

	const operationDate = moment(orb1Record.selectedDate, "YYYY-MM-DD").format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<ORB1TableRows
				record={orb1Record}
				tableRows={[
					[operationDate, "C", renderItemNumberOnDisposalMethod(), renderMainTDOnDisposalMethod()],
					[null, null, "NOTE", orb1Record.remarks],
				]}
			/>
		);
	}

	function renderMainTDOnDisposalMethod() {
		switch (orb1Record.item12P4.disposalMethod) {
			case EORB1Item12P4DisposalMethod.MISC_TANKS:
				return (
					<div>
						{sourceSludgeTank.transferQuantity.toFixed(2)} M³ FUEL FROM{" "}
						{marpolUtils.getFormattedName(sourceSludgeTank.selectedTank)}, RETAINED{" "}
						{(
							marpolUtils.getQuantityForCalculation(sourceSludgeTank.selectedTank) -
							sourceSludgeTank.transferQuantity
						).toFixed(2)}{" "}
						M³ TRANSFERRED TO {marpolUtils.getFormattedName(orb1Record.item12P4.miscTank)}
					</div>
				);
		}
		return null;
	}

	function renderItemNumberOnDisposalMethod() {
		return 12.4;
	}

	return renderMain();
}

export default ORB1GroupC7Preview;
